import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

type CaptionAlign = 'left' | 'center' | 'right';

interface CaptionProps {
    children: React.ReactNode;
    align?: CaptionAlign;
    className?: string;
}

export function Caption({ children, align, className }: CaptionProps) {
    return (
        <StyledCaption $align={align} className={className}>
            {children}
        </StyledCaption>
    );
}

const StyledCaption = styled('span', {
    shouldForwardProp: (prop) => prop !== '$align',
})<{ $align?: CaptionAlign }>(({ $align }) => ({
    fontSize: 13,
    fontWeight: 400,
    color: Colors.textSecondary,
    textAlign: $align,
    lineHeight: 1.15,
}));
